import { render, staticRenderFns } from "./FormTraspaso.vue?vue&type=template&id=439a8c9c&scoped=true"
import script from "./FormTraspaso.vue?vue&type=script&lang=js"
export * from "./FormTraspaso.vue?vue&type=script&lang=js"
import style0 from "./FormTraspaso.vue?vue&type=style&index=0&id=439a8c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439a8c9c",
  null
  
)

export default component.exports